import React from 'react';

/**
 * UploadMode Component
 * 
 * File upload dropzone with progress indicator
 */
const UploadMode = ({
  uploadError,
  setUploadError,
  isDragging,
  isUploading,
  uploadProgress,
  dropZoneRef,
  fileInputRef,
  handleDragEnter,
  handleDragLeave,
  handleDragOver,
  handleDrop,
  handleFileSelect,
  openFilePicker,
  isUpdate,
  deliverable,
}) => {
  return (
    <div className="deliverable-submit-modal__upload-mode">
      {uploadError && (
        <div className="deliverable-submit-modal__error">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span>{uploadError}</span>
          <button onClick={() => setUploadError(null)}>×</button>
        </div>
      )}
      
      <div 
        ref={dropZoneRef}
        className={`deliverable-submit-modal__dropzone ${isDragging ? 'deliverable-submit-modal__dropzone--dragging' : ''} ${isUploading ? 'deliverable-submit-modal__dropzone--uploading' : ''}`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => !isUploading && openFilePicker()}
      >
        <input
          ref={fileInputRef}
          type="file"
          className="deliverable-submit-modal__file-input"
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />
        
        {isUploading ? (
          <div className="deliverable-submit-modal__uploading">
            <div className="deliverable-submit-modal__progress-ring">
              <svg viewBox="0 0 36 36">
                <circle cx="18" cy="18" r="16" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="2" />
                <circle 
                  cx="18" cy="18" r="16" 
                  fill="none" 
                  stroke="#f97316" 
                  strokeWidth="2"
                  strokeDasharray={`${(uploadProgress?.progress || 0) * 1.005} 100.5`}
                  transform="rotate(-90 18 18)"
                />
              </svg>
              <span className="deliverable-submit-modal__progress-text">{uploadProgress?.progress || 0}%</span>
            </div>
            <p className="deliverable-submit-modal__uploading-text">
              Uploading {uploadProgress?.filename}...
            </p>
          </div>
        ) : (
          <>
            <div className="deliverable-submit-modal__dropzone-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </div>
            <p className="deliverable-submit-modal__dropzone-text">
              {isDragging ? 'Drop file here' : 'Drag & drop or click to upload'}
            </p>
            <p className="deliverable-submit-modal__dropzone-hint">
              {isUpdate && deliverable?.submittedFilename 
                ? `You submitted "${deliverable.submittedFilename}" before. Upload a new file to replace it.`
                : 'The file will also show up in your attachments.'}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default UploadMode;
